import React from 'react';
import PropTypes from 'prop-types';

const formContextAware = (WrappedComponent) => {
  class FormContextAwareComponent extends React.PureComponent {
    constructor(props, context) {
      super(props, context);

      if (!context.form) {
        throw new Error('Component must be inside a <Form/>.');
      }

      this.state = {
        isSubmitting: false,
        isValid: true,
        isValidating: false,
      };

      this.handleContextChange = this.handleContextChange.bind(this);

      this._unregisterContext = context.form.onStateChange(this.handleContextChange);
    }

    render() {
      let { isSubmitting, isValid, isValidating } = this.state;

      return (
        <WrappedComponent
          isSubmitting={isSubmitting}
          isSyntheticForm={this.context.form.isSyntheticForm}
          isValid={isValid}
          isValidating={isValidating}
          submit={this.context.form.submit}
          {...this.props}
        />
      );
    }

    handleContextChange(context) {
      if (context.isSubmitting !== this.state.isSubmitting) {
        this.setState({ isSubmitting: context.isSubmitting });
      }

      if (context.isValid !== this.state.isValid) {
        this.setState({ isValid: context.isValid });
      }

      if (context.isValidating !== this.state.isValidating) {
        this.setState({ isValidating: context.isValidating });
      }
    }

    componentWillUnmount() {
      this._unregisterContext();
    }
  }

  FormContextAwareComponent.contextTypes = {
    form: PropTypes.object,
  };

  return FormContextAwareComponent;
};

formContextAware.childProps = {
  isSubmitting: PropTypes.bool,
  isSyntheticForm: PropTypes.bool,
  isValid: PropTypes.bool,
  isValidating: PropTypes.bool,
  submit: PropTypes.func,
};

export default formContextAware;
